module.exports = __webpack_public_path__ + "static/media/PushtimargImage27.f4763258.jpg";